exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".prime-tree-context-menu .p-menuitem-link:hover {\n  background-color: #8d7dcf !important; }\n  .prime-tree-context-menu .p-menuitem-link:hover * {\n    color: white !important; }\n\n.prime-tree-context-menu .p-menuitem-link.p-disabled {\n  display: none !important; }\n", ""]);

